var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import { CatalogModifierListSelectionType as ModifierListSelectionTypeProto, CatalogModifierListModifierType as ModifierListModifierTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
const selectionTypesObject = {};
Object.keys(ModifierListSelectionTypeProto).forEach(key => {
  const _key = key;
  selectionTypesObject[_key] = _key;
});
export const SelectionType = Object.freeze(selectionTypesObject);
const modifierTypesObject = {};
Object.keys(ModifierListModifierTypeProto).forEach(key => {
  const _key = key;
  modifierTypesObject[_key] = _key;
});
export const ModifierType = Object.freeze(modifierTypesObject);
const TEXT_MODIFIER_MAX_LENGTH = 150;
let Data = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('number'), _dec4 = attr('number'), _dec5 = attr('number'), _dec6 = attr('string', {
  defaultValue: SelectionType.SINGLE
}), _dec7 = attr('string', {
  defaultValue: ModifierType.LIST
}), _dec8 = attr('boolean', {
  allowNull: true
}), _dec9 = attr('number', {
  allowNull: true
}), _dec10 = attr('boolean', {
  allowNull: true
}), _dec11 = attr('number', {
  defaultValue: TEXT_MODIFIER_MAX_LENGTH
}), _dec12 = attr('boolean', {
  defaultValue: false
}), _dec13 = fragmentArray('connect/channel-integrations'), _class = class Data extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "internalName", _descriptor2, this);
    _initializerDefineProperty(this, "ordinal", _descriptor3, this);
    _initializerDefineProperty(this, "minSelectedModifiers", _descriptor4, this);
    _initializerDefineProperty(this, "maxSelectedModifiers", _descriptor5, this);
    _initializerDefineProperty(this, "selectionType", _descriptor6, this);
    _initializerDefineProperty(this, "modifierType", _descriptor7, this);
    _initializerDefineProperty(this, "allowQuantities", _descriptor8, this);
    _initializerDefineProperty(this, "maxQuantity", _descriptor9, this);
    _initializerDefineProperty(this, "isConversational", _descriptor10, this);
    // Text modifier specific attributes
    _initializerDefineProperty(this, "maxLength", _descriptor11, this);
    _initializerDefineProperty(this, "textRequired", _descriptor12, this);
    _initializerDefineProperty(this, "channelIntegrations", _descriptor13, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "internalName", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "minSelectedModifiers", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "maxSelectedModifiers", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectionType", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "modifierType", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "allowQuantities", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "maxQuantity", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isConversational", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "maxLength", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "textRequired", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "channelIntegrations", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Data as default };